import { Scale } from "lucide-react";
import { LegalAccordion } from "./LegalAccordion";

export const formatApiErrorDetail = (detail, fallback = "Κάτι πήγε στραβά. Δοκιμάστε ξανά.") => {
  if (detail == null) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

/** Λευκό layout σύνδεσης: αριστερά το μήνυμα, δεξιά η κάρτα (login / ξέχασα κωδικό / επαναφορά). */
export const AuthShell = ({ children }) => (
  <div className="min-h-screen bg-white text-slate-900 flex flex-col lg:flex-row" data-testid="auth-shell">
    <aside className="relative lg:w-[52%] flex flex-col px-8 py-10 sm:px-14 lg:px-20 lg:py-14 border-b lg:border-b-0 lg:border-r border-slate-200">
      <div className="flex items-center gap-5" data-testid="auth-brand">
        <div className="w-20 h-20 sm:w-24 sm:h-24 lg:w-28 lg:h-28 rounded-3xl bg-slate-900 flex items-center justify-center shadow-lg shrink-0">
          <Scale className="w-11 h-11 sm:w-14 sm:h-14 lg:w-16 lg:h-16 text-white" />
        </div>
        <div className="min-w-0">
          <div className="font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tight">Themis Pro</div>
          <div className="mt-2 text-lg sm:text-xl lg:text-[27px] font-medium text-slate-600 leading-snug whitespace-nowrap">Σύστημα Διαχείρισης Γραμματείας Δικαστηρίου</div>
        </div>
      </div>
      <div className="mt-12 lg:mt-16 max-w-xl" data-testid="auth-tagline">
        <div className="w-14 h-1.5 bg-slate-900 rounded-full mb-8" />
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-slate-900" data-testid="auth-tagline-1">
          Καινοτομία στην πράξη
        </h1>
        <p className="mt-6 text-2xl sm:text-3xl font-semibold text-slate-700" data-testid="auth-tagline-2">
          Απόδοση σε κάθε στάδιο
        </p>
        <p className="mt-4 text-base md:text-lg text-slate-500 leading-relaxed" data-testid="auth-tagline-3">
          Διασφάλιση ποιότητας και προθεσμιών στον ΚΠολΔ
        </p>
        <div className="mt-10">
          <LegalAccordion />
        </div>
      </div>
      <p className="text-xs text-slate-400 mt-auto pt-10">Themis Pro &copy; {new Date().getFullYear()}</p>
    </aside>
    <main className="relative flex-1 flex items-center justify-center px-6 py-12 sm:px-10 bg-white lg:sticky lg:top-0 lg:h-screen lg:self-start">
      <div className="relative w-full max-w-md rounded-3xl bg-white border border-slate-200/80 p-8 sm:p-10
                      shadow-[0_32px_80px_-20px_rgba(15,23,42,0.35),0_12px_28px_-12px_rgba(15,23,42,0.18)]
                      transition-shadow duration-300 hover:shadow-[0_40px_90px_-20px_rgba(15,23,42,0.42),0_16px_32px_-12px_rgba(15,23,42,0.2)]"
        data-testid="auth-card">
        <div aria-hidden className="absolute inset-x-10 top-0 h-1 rounded-b-full bg-slate-900" />
        {children}
      </div>
    </main>
  </div>
);
